import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p style={{ color: '#6b7280', fontSize: '14px' }}>{message}</p>
    </div>
  );
};

export default LoadingSpinner;
